var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    { staticClass: "article-list__item" },
    [
      _c("a", {
        class: [
          "image-container",
          { "image-container--is-empty": !_vm.bkgImageStyle(_vm.item.fimg) }
        ],
        style: _vm.bkgImageStyle(_vm.item.fimg),
        attrs: {
          href: _vm.item.url,
          rel: "external",
          title: _vm.item.title.rendered
        }
      }),
      _vm._v(" "),
      _vm._t("content", [
        _c(
          "div",
          { staticClass: "content-container" },
          [
            _vm.item.url
              ? _c("h3", { staticClass: "heading" }, [
                  _c("a", {
                    attrs: {
                      href: _vm.item.url,
                      rel: "external",
                      title: _vm.item.title.rendered
                    },
                    domProps: { innerHTML: _vm._s(_vm.item.title.rendered) }
                  })
                ])
              : _c("h3", {
                  staticClass: "heading",
                  domProps: { innerHTML: _vm._s(_vm.item.title.rendered) }
                }),
            _vm._v(" "),
            _vm.item.displayDate
              ? _c("p", { staticClass: "date" }, [
                  _vm._v(_vm._s(_vm.item.displayDate))
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm._t("details"),
            _vm._v(" "),
            _vm.item.description
              ? _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$options.filters.truncate(
                        _vm.$options.filters.paragraphWrap(
                          _vm.item.description
                        ),
                        80
                      )
                    )
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm._t("button", [
              _vm.item.url
                ? _c(
                    "a",
                    {
                      staticClass: "btn read-more",
                      attrs: { href: _vm.item.url }
                    },
                    [_vm._v("Read More")]
                  )
                : _vm._e()
            ])
          ],
          2
        )
      ]),
      _vm._v(" "),
      _vm._t("footer")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /Users/lili/Sites/southern-highlands.com.au-2018/web/app/themes/wisdom/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/Users/lili/Sites/southern-highlands.com.au-2018/web/app/themes/wisdom/node_modules/vue-loader/lib?{}!./scripts/vue/ArticleListItem.vue?vue&type=template&id=a2f8453a&
// module id = 38
// module chunks = 0 2 3 4 6